module.exports = __webpack_public_path__ + "static/media/christofer_sanrow.624e7509.png";